import React from 'react';
import SiteDeprecated from './pages/SiteDeprecated';

function App() {
  return <SiteDeprecated />;
}

export default App;
